import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

export default function Performance() {
    const handleLogout = (event) => {
        event.preventDefault();
        sessionStorage.clear('token')
        window.location = '/login'
    }

    return (
        <div>
            <div className='navbar'>
                <a href="/home">
                    <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
                </a>
                <button className="logout-btn" onClick={handleLogout}>
                    Log out
                </button>
            </div>
            <div className="global-market-container">
                <div className="performance-grid">
                    <Link className="global-market-menuitem" to="/performance">ยอดขายโดยรวม</Link>
                    <Link className="global-market-menuitem" to="/performance/progress">ผลดำเนินงาน</Link>
                    <Link className="global-market-menuitem" to="/performance/KPIs">KPIs</Link>
                </div>
                <div className="geomap-powerbi">
                    <iframe
                        title="Sales Dashboard V3 (Bulid by Marketingteam)"
                        width="1140"
                        height="541.25"
                        src="https://app.powerbi.com/reportEmbed?reportId=cb12de6d-57f2-417c-a4a8-17b092c4f96e&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095"
                        frameborder="0"
                        allowFullScreen="true"
                    ></iframe>
                </div>
            </div>
        </div>
    );
}

